module.exports = __webpack_public_path__ + "static/media/menu-social-menu-button.630510a0.jpg";